import {
  postRequest
} from '@/utils/api'

// 查询充电过程上报列表
export function listChargingReport(params) {
  return postRequest('/api/coo/charging-report/list', params)
}

// 查询充电过程上报详情
export function getChargingReport(id) {
  return postRequest('/api/coo/charging-report/get', { id })
}

// 新增充电过程上报
export function addChargingReport(data) {
  return postRequest('/api/coo/charging-report/add', data)
}

// 更新充电过程上报
export function updateChargingReport(data) {
  return postRequest('/api/coo/charging-report/update', data)
}

// 删除充电过程上报
export function delChargingReport(id) {
  return postRequest('/api/coo/charging-report/delete', { id })
}

// 推送单条上报
export function pushChargingReport(id) {
  return postRequest('/api/coo/charging-report/push', { id })
}

// 批量推送上报
export function batchPushChargingReport(data) {
  return postRequest('/api/coo/charging-report/push-batch', data)
}

// 查询推送日志
export function listPushLog(params) {
  return postRequest('/api/coo/push/log/list', params)
}

// 重新推送
export function retryPush(id) {
  return postRequest('/api/coo/push/log/retry', { id })
}
